module.exports = __webpack_public_path__ + "img/refresh.d90b2ed8.png";